import { Info } from 'lucide-react';
import { useState, useMemo } from 'react';

import { CategoryTabs } from './components/category-tabs';
import { FavoritesSection } from './components/favorites-section';
import { QuestionCard } from './components/question-card';
import { QuestionSearch } from './components/question-search';
import { checkInQuestions } from './data/check-in-questions';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Separator } from '@/components/ui/separator';


export function CheckInsPage() {
  const [category, setCategory] = useState('all');
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    let questions = checkInQuestions;
    if (category !== 'all') {
      questions = questions.filter((q) => q.category === category);
    }
    if (search.trim()) {
      const term = search.toLowerCase();
      questions = questions.filter(
        (q) =>
          q.question.toLowerCase().includes(term) ||
          q.contextNote.toLowerCase().includes(term),
      );
    }
    return questions;
  }, [category, search]);

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <h1 className="text-2xl font-bold">Check-in Questions</h1>

      <Alert variant="info">
        <Info className="h-4 w-4" />
        <AlertDescription>
          These questions are designed to be part of normal 1:1 conversations. They should never be
          asked as a "menopause check-in" or framed around someone's health status. The goal is to
          create an environment where anyone can raise needs without needing to disclose personal
          medical information.
        </AlertDescription>
      </Alert>

      <FavoritesSection />

      <Separator />

      <div className="space-y-4">
        <QuestionSearch value={search} onChange={setSearch} />
        <CategoryTabs value={category} onChange={setCategory} />
      </div>

      <div className="space-y-2">
        {filtered.length === 0 ? (
          <p className="py-8 text-center text-muted-foreground">
            No questions match your search.
          </p>
        ) : (
          filtered.map((q) => <QuestionCard key={q.id} question={q} />)
        )}
      </div>
    </div>
  );
}
